import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../api/v1";
import { ApiResponse } from "../../../../../../types/api-response";
import axios from "../../../../../../utils/axiosInceptor";

export type RecallChequeRequest = {
  pdcId: string;
  chequeNumber: string;
  recallType: "recallOnly" | "replaceWithNewReceipt";
  subPdcId?: string;
  subChequeNumber?: string;
  recallReason?: string;
  waiveOff?: boolean;
  modeOfPayment?: string;
  amountToPay?: number;
  documentNo?: string;
  bankName?: string;
  paidDate?: string;
  depositDate?: string;
  depositTo?: string;
  depositToBank?: string;
};

const recallChequeRequest = async (payload: RecallChequeRequest) => {
  const url = `${apiV1Endpoint}/booking/recallChequeRequest`;

  const response = await axios.post<ApiResponse>(url, payload);
  return response.data.result;
};

type UseRecallChequeRequestOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useRecallChequeRequest = (options: UseRecallChequeRequestOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: recallChequeRequest,
    onSuccess,
    onError,
  });

  return {
    recallChequeRequest: mutateAsync,
    isPendingRecallChequeRequest: isPending,
  };
};
